export default "<event-analytics customer-id=\"$ctrl.customerId\" event-id=\"$ctrl.eventId\" auth=\"$ctrl.auth\"/>";